import { createUseStyles } from 'react-jss'
import { WHITE } from '@omnilert/components'

export default createUseStyles({
  bodyText: {
    marginBottom: '15px !important'
  },
  button: {
    marginBottom: '25px',
    width: '100%'
  },
  icon: ({ iconVariant }) => ({
    '& path': {
      stroke: `url(#${iconVariant})`
    }
  }),
  iconContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  modalTextContainer: {
    '& > div': {
      marginBottom: '10px',
      padding: '5px'
    },
    alignItems: 'center',
    color: WHITE,
    display: 'flex',
    flexDirection: 'column',
    margin: '15px 0',
    textAlign: 'center'
  }
})

